/* eslint-disable no-useless-escape */

import { ReactNode } from 'react';

export function removeSpecialCharsAndSpaces(str: string) {
  return str.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/\s]/gi, '');
}

export function plural(count: number, onOne: ReactNode, onMany: ReactNode) {
  return count === 1 ? onOne : onMany;
}

/** Title-case a `-`/`_`-separated name, e.g. `mime_type` -> `Mime Type`. */
export const titleCase = (raw: string): string =>
  raw
    .split(/[-_]/)
    .filter(Boolean)
    .map((token) => token.charAt(0).toUpperCase() + token.slice(1))
    .join(' ');
